<template>
  <MasonryWall
    :items="images"
    :ssr-columns="1"
    :column-width="240"
    :gap="20"
    :columns="4"
    :max-columns="4"
  >
    <template #default="{ item, index }">
      <button
        class="masonry-gallery__button"
        :key="`${item.imgLink}-${index}`"
        data-bs-toggle="modal"
        :data-bs-target="'#' + targetId"
        @click="onImageClick(index)"
        type="button"
      >
        <span class="visually-hidden">Open modal gallery</span>
        <img :src="item.imgLink" :alt="item.altText" />
      </button>
    </template>
  </MasonryWall>
</template>

<script>
import MasonryWall from "@yeger/vue-masonry-wall";

export default {
  name: "MasonryGallery",
  components: {
    MasonryWall,
  },
  props: {
    images: Object,
    targetId: String,
    onImageClick: Function,
  },
};
</script>
